/**
 * 获取游戏卡片底部数据信息
 * @param {*} params
 */
export function getGameBottomData({
  versionName,
  developer,
  privacyJump,
  permissionJump,
}) {
  return [
    {
      tag: 'div',
      class: '',
      href: '',
      text: `${versionName} 版本`,
      // text: `${versionName}`,
      isShow: versionName,
    },
    {
      tag: 'div',
      class: '',
      href: '',
      text: developer,
      isShow: developer,
    },
    {
      tag: 'a',
      class: 'url game-box-bottom__item__bold',
      href: privacyJump,
      text: '隐私',
      isShow: privacyJump,
    },
    {
      tag: 'a',
      class: 'url game-box-bottom__item__bold',
      href: permissionJump,
      text: '权限',
      isShow: /^http/.test(permissionJump), // http 链接时展示
    },
  ].filter((item) => item.isShow);
}

// 三个位置的组件名称
export const nameMap = {
  gameOperationTop: 'gameOperationTop',
  gameOperationBottom: 'gameOperationBottom',
  gameOperationFloat: 'gameOperationFloat',
};
